export default __webpack_public_path__ + "static/media/wave.c2f39413.png";